import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import adminApi from "@/lib/adminApi";

const AdminDemandes = () => {
  const [contacts, setContacts] = useState(null);

  useEffect(() => {
    adminApi.get("/contacts").then(({ data }) => setContacts(data)).catch(() => setContacts([]));
  }, []);

  if (!contacts) return <p className="text-white/40">Chargement…</p>;

  return (
    <div data-testid="admin-demandes" className="space-y-6">
      <h1 className="font-display uppercase text-4xl tracking-wide">Contact / Demandes</h1>
      <p className="text-white/40 text-sm">Messages reçus via le formulaire de contact et les demandes de devis.</p>
      <div className="space-y-3">
        {contacts.map((c) => (
          <div key={c.id} data-testid={`contact-msg-${c.id}`} className="bg-noir-surface border border-noir-border p-5">
            <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
              <Mail size={15} className="text-gold" />
              <p className="font-semibold text-sm">{c.prenom} {c.nom}</p>
              <a href={`mailto:${c.email}`} className="text-xs text-gold/80 hover:text-gold">{c.email}</a>
              {c.telephone && <span className="text-xs text-white/50">{c.telephone}</span>}
              <span className="ml-auto text-[10px] text-white/35">{c.created_at ? new Date(c.created_at).toLocaleString("fr-FR") : ""}</span>
            </div>
            <p className="mt-2 text-xs font-bold uppercase tracking-[0.15em] text-gold/70">{c.objet}</p>
            <p className="mt-2 text-sm text-white/65 whitespace-pre-wrap">{c.message}</p>
          </div>
        ))}
        {contacts.length === 0 && <p className="text-white/40 text-sm">Aucun message pour le moment.</p>}
      </div>
    </div>
  );
};

export default AdminDemandes;
